import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";
import axios from "axios";


class HolidayService {



    static getHoliday(item) {
        const user = JSON.parse(localStorage.getItem("user"));
        const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

        let api = `${API_BASE_URL}${dynamicPaths.getHoliday}`;
        const params = new URLSearchParams();


        params.append("limit", item?.limit || 25);
        params.append("page", item?.page || 1);

        // optional filters
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }


    static addHoliday(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addHoliday}`;
        return axiosInstance
            .post(api, data)

    }

    static editHoliday(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editHoliday}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteHoliday(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteHoliday}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default HolidayService;
